export enum DataSourceSettingsTabType {
  GENERAL = 'general',
  SHARING = 'sharing',
  FIELD_PRESETS = 'field-presets',
  DATA_IMPORT = 'data-import',
}
